import { ReportingLoaderBaseConfig } from '../../../base';
import { DocumentNewLoader } from './documentNewInterface';
import { DocumentNewAggregate } from './documentNewModel';

export function createDocumentNewLoader(
    config: ReportingLoaderBaseConfig
): DocumentNewLoader {
    return {
        useLoad(context, props): DocumentNewAggregate {
            // Empty state - just return minimal structure
            return {
                workspace: {
                    current: {
                        id: '1', // placeholder workspace id
                    },
                },
            };
        },
    };
}
